import { Component, input, output, inject } from '@angular/core';

import { UserProfileStore } from '../store/user-profile.store';

@Component({
  standalone: true,
  imports: [],
  selector: 'sb-session-invalidate-button',
  template: `
    <div class="flex-shrink-0 w-full sm:w-auto sm:ml-4">
      @if (!isCurrentSession()) {
      <button
        (click)="onInvalidate()"
        [disabled]="userProfileStore.isLoadingSessions()"
        class="w-full sm:w-auto inline-flex items-center justify-center px-3 py-2 sm:py-1.5 border border-transparent text-sm sm:text-xs font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 min-h-[44px] sm:min-h-0"
      >
        @if (userProfileStore.isLoadingSessions()) {
        <svg
          class="animate-spin -ml-1 mr-2 h-4 w-4 sm:h-3 sm:w-3 text-red-700"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <span class="sm:hidden">Revoking Access...</span>
        <span class="hidden sm:inline">Revoking...</span>
        } @else {
        <svg
          class="w-4 h-4 sm:w-3 sm:h-3 mr-2 sm:mr-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
        <span class="sm:hidden">Revoke Access</span>
        <span class="hidden sm:inline">Revoke Access</span>
        }
      </button>
      } @else {
      <div
        class="w-full sm:w-auto inline-flex items-center justify-center px-3 py-2 sm:py-1.5 text-sm sm:text-xs font-medium text-gray-500 bg-gray-50 rounded-md min-h-[44px] sm:min-h-0"
      >
        <svg
          class="w-4 h-4 sm:w-3 sm:h-3 mr-2 sm:mr-1"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        Protected
      </div>
      }
    </div>
  `,
})
export class SessionInvalidateButtonComponent {
  // @ts-ignore TS4029
  public userProfileStore = inject(UserProfileStore);

  sessionId = input.required<string>();
  isCurrentSession = input.required<boolean>();
  invalidateSession = output<string>();

  onInvalidate() {
    this.invalidateSession.emit(this.sessionId());
  }
}
